import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

import eggMachine from './eggMachine'
import greedyHiya from './greedyHiya'
import guessGift from './guessGift'
import familyEggMachine from './familyEggMachine'

export default [
  // {
  //   path: '/game/fruitSlot',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         /* webpackChunkName: "page-game-fruitSlot" */ '~/pages/game/fruitSlot'
  //       )
  //   ),
  // },
  // {
  //   path: '/game/roulette',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         /* webpackChunkName: "page-game-roulette" */ '~/pages/game/roulette'
  //       )
  //   ),
  // },
  {
    path: '/game/LuckySlot',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-LuckySlot" */ '~/pages/game/LuckySlot'
        )
    ),
  },
  // {
  //   path: '/game/HorseGame',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         /* webpackChunkName: "page-game-HorseGame" */ '~/pages/game/HorseGame'
  //       )
  //   ),
  // },
  // {
  //   path: '/game/WorldCup',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         /* webpackChunkName: "page-game-WorldCup" */ '~/pages/game/WorldCup'
  //       )
  //   ),
  // },
  // {
  //   path: '/game/LuckyBigWheel',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         /* webpackChunkName: "page-game-LuckyBigWheel" */ '~/pages/game/LuckyBigWheel'
  //       )
  //   ),
  // },
  // {
  //   path: '/game/guessbox',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         /* webpackChunkName: "page-game-guessbox" */ '~/pages/game/guessbox'
  //       )
  //   ),
  // },
  // {
  //   path: '/game/guessbox/throneEntrance',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         /* webpackChunkName: "page-game-guessbox-throneEntrance" */ '~/pages/game/guessbox/Throne/components/entrance'
  //       )
  //   ),
  // },
  // {
  //   path: '/game/GreedyBox',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         /* webpackChunkName: "page-game-GreedyBox" */ '~/pages/game/GreedyBox'
  //       )
  //   ),
  // },
  // {
  //   path: '/game/GreedyBox/throneEntrance',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         /* webpackChunkName: "page-game-GreedyBox-throneEntrance" */ '~/pages/game/GreedyBox/Throne/components/entrance'
  //       )
  //   ),
  // },
  // {
  //   path: '/game/LuckyHiya',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         /* webpackChunkName: "page-game-LuckyHiya" */ '~/pages/game/LuckyHiya'
  //       )
  //   ),
  // },
  ...greedyHiya,
  // 礼物猜一猜
  // ...guessGift,
  // // 扭蛋机
  // ...eggMachine,
  // {
  //   path: '/game/GreedyPro/:gameId',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         /* webpackChunkName: "page-game-GreedyPro" */ '~/pages/game/GreedyProGame'
  //       )
  //   ),
  // },
  // {
  //   path: '/game/GreedyPro/banner/:gameId',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         /* webpackChunkName: "page-game-GreedyPro-banner" */ '~/pages/game/GreedyProGame/Banner'
  //       )
  //   ),
  // },
  // {
  //   // TP游戏
  //   path: '/game/TeenPatti',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         // /404 TeenPatti 方便快速回滚之前的版本
  //         /* webpackChunkName: "page-game-TeenPatti" */ '~/pages/game/TeenPatti'
  //       )
  //   ),
  // },
  // {
  //   // TP游戏
  //   path: '/game/TeenPatti/jpEntance',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         // /404
  //         /* webpackChunkName: "page-game-TeenPatti-jpEntance" */ '~/pages/game/TeenPatti/entrance'
  //       )
  //   ),
  // },
  // {
  //   // 砸金蛋游戏
  //   path: '/game/HitEgg',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         // /404
  //         /* webpackChunkName: "page-game-HitEgg" */ '~/pages/game/HitEgg'
  //       )
  //   ),
  // },
  {
    // slot游戏中转页
    path: '/game/SlotMidPage',
    exact: true,
    component: loadable(
      () =>
        import(
          // /404
          /* webpackChunkName: "page-game-SlotMidPage" */ '~/pages/game/SlotMidPage'
        )
    ),
  },
  /** 家族 扭蛋 抽奖 */
  ...familyEggMachine,
] as RouteConfig[]
